// extracted by mini-css-extract-plugin
export default {"modal":"view-replies_modal__RzUgD","content":"view-replies_content__3qAQ5"};